import { Pipe, PipeTransform } from '@angular/core';
import { IDuration } from '../../models/odb-usage-level-4.model';
import { TranslationService } from '@dch/ng-common';

const ONE_KB_IN_BYTE = 2 ** 10;
const ONE_MB_IN_BYTE = 2 ** 20;
const ONE_GB_IN_BYTE = 2 ** 30;

@Pipe({
  name: 'duration',
  standalone: false,
})
export class DurationPipe implements PipeTransform {
  constructor(private translationService: TranslationService) {}

  transform({ type, value }: IDuration): string {
    let result = '';

    const valueAsNum = Number(value);
    if (!isNaN(valueAsNum)) {
      if (type === 'sec') {
        result = this.getFormattedTime(valueAsNum);
      } else if (type === 'bytes' || type === 'kb' || type === 'mb') {
        let valueInBytes: number;
        if (type === 'bytes') {
          valueInBytes = valueAsNum;
        } else if (type === 'kb') {
          valueInBytes = valueAsNum * ONE_KB_IN_BYTE;
        } else if (type === 'mb') {
          valueInBytes = valueAsNum * ONE_MB_IN_BYTE;
        }

        result = this.getFormattedData(valueInBytes);
      }
    }
    return result;
  }

  private getFormattedTime(valueInSec: number): string {
    let result = '';

    const MIN_UNIT_TRANSLATION = this.translationService.getTranslatedValueFor(
      'bills.cover.usageLevel4.table.minUnit'
    );

    if (valueInSec < 60) {
      result = `< 1 ${MIN_UNIT_TRANSLATION}`;
    } else if (valueInSec >= 60) {
      const roundedValueInMin =
        Math.floor(valueInSec / 60) + (valueInSec % 60 > 30 ? 1 : 0);
      result = `${roundedValueInMin} ${MIN_UNIT_TRANSLATION}`;
    }
    return result;
  }

  private getFormattedData(valueInBytes: number): string {
    const MB_UNIT_TRANSLATION = this.translationService.getTranslatedValueFor(
      'bills.cover.usageLevel4.table.mbUnit'
    );
    const GB_UNIT_TRANSLATION = this.translationService.getTranslatedValueFor(
      'bills.cover.usageLevel4.table.gbUnit'
    );

    let result = '';
    if (valueInBytes < ONE_GB_IN_BYTE) {
      const valueInMb = valueInBytes / ONE_MB_IN_BYTE;
      if (valueInMb < 1) {
        result = `${parseFloat(valueInMb.toFixed(3))} ${MB_UNIT_TRANSLATION}`;
      } else {
        const roundedValueInMb =
          Math.floor(valueInMb) + (valueInMb % 1 >= 0.5 ? 1 : 0);
        result = `${roundedValueInMb} ${MB_UNIT_TRANSLATION}`;
      }
    } else {
      const valueInGb = valueInBytes / ONE_GB_IN_BYTE;
      result = `${parseFloat(valueInGb.toFixed(3))} ${GB_UNIT_TRANSLATION}`;
    }

    return result;
  }
}
